import type {
    IOphthalmologyAsset,
    OphthalmologyFilePlacement,
} from '../../../../../../common/validation/customControls/ophthalmology';

export function getFilesByPlacement(files: IOphthalmologyAsset[] | undefined, placement: OphthalmologyFilePlacement) {
    if (files && files.length > 0) {
        return files.filter((file: IOphthalmologyAsset) => file.placement === placement);
    } else {
        return [];
    }
}
